export const COOKIE_ACCESS_TOKEN = 'access_token';
export const COOKIE_ACCESS_TOKEN_SOCIAL = 'access_token_social';
export const COOKIE_ACCESS_TOKEN_INVEST = 'access_token_invest';
export const COOKIE_ACCESS_TOKEN_RESEARCH = 'access_token_research';
export const COOKIE_ACCESS_TOKEN_BETRIEB = 'access_token_betrieb';
export const COOKIE_ACCESS_TOKEN_BEREADY = 'access_token_be-ready';
export const COOKIE_PREFERRED_INSTITUTE_NUMBER_LOGGED_IN = 'preferredInstituteNumberLoggedIn';
export const COOKIE_JWT_INVEST = 'jwt_invest';
export const COOKIE_JWT_ALFA_BEREADY = 'jwt-alfa_be-ready';
export const COOKIE_JWT_BEREADY = 'jwt_be-ready';
export const MSG_STOP_EXECUTION = 'Stop the execution.';

export const SESSION_PKCE_CODE_VERIFIER = 'pkce_code_verifier';
